import { array, func, bool } from 'prop-types';
import React from 'react';
import { Button, Icon, Tooltip, Stack, Shelf, Text } from '@chaser/components';
import pluralize from 'pluralize';
import { formatDate } from '../../../util/time';
import style from './SuggestedInvoicesList.module.scss';
import useOrganisationUtils from '../../../hooks/useOrganisationUtils';

const SuggestedInvoicesList = ({ suggestedInvoices, addInvoice, loading, disabled = false }) => {
  const { formatCurrency } = useOrganisationUtils();
  if (!suggestedInvoices || suggestedInvoices.length === 0) return null;
  const totalInvoices = suggestedInvoices.length;
  const grammar = totalInvoices === 1 ? 'is' : 'are';
  return (
    <Stack gap="xsmall">
      <Text fontSize="xsmall">
        There {grammar} {totalInvoices} more {pluralize('invoice', totalInvoices)} from this
        customer that {grammar} eligible for collection:
      </Text>
      <Shelf gap="xsmall">
        {suggestedInvoices.map(invoice => (
          <Tooltip
            key={invoice._id}
            className={style.buttonTooltip}
            content={`Due ${formatDate(invoice.DueDate)}\nOutstanding ${formatCurrency(
              invoice.AmountDue,
              invoice.CurrencyCode,
            )}`}
          >
            <Button
              loading={loading}
              disabled={disabled}
              appearance="secondary"
              size="micro"
              icon={<Icon size="16" color="Mid Neutral 2" name="plus-circle" />}
              onClick={async () => {
                addInvoice(invoice);
              }}
            >
              <Text>{invoice.InvoiceNumber}</Text>
            </Button>
          </Tooltip>
        ))}
      </Shelf>
    </Stack>
  );
};

SuggestedInvoicesList.propTypes = {
  suggestedInvoices: array.isRequired,
  addInvoice: func.isRequired,
  loading: bool.isRequired,
  disabled: bool,
};

export default SuggestedInvoicesList;
